module.exports = __webpack_public_path__ + "images/mobile/home/screenshot-role@2x-6244b423992d0a305b4772abd726b58c.png";